/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NullableRangeDtoFromJSON, NullableRangeDtoToJSON, } from './NullableRangeDto.js';
/**
 * Check if a given object implements the CandidateMinimum interface.
 */
export function instanceOfCandidateMinimum(value) {
    if (!('cityName' in value) || value['cityName'] === undefined)
        return false;
    if (!('searchLocationName' in value) || value['searchLocationName'] === undefined)
        return false;
    if (!('searchLocationRadius' in value) || value['searchLocationRadius'] === undefined)
        return false;
    if (!('yearsExperience' in value) || value['yearsExperience'] === undefined)
        return false;
    if (!('educationLevel' in value) || value['educationLevel'] === undefined)
        return false;
    if (!('personalCharacteristics' in value) || value['personalCharacteristics'] === undefined)
        return false;
    if (!('personalityTypeId' in value) || value['personalityTypeId'] === undefined)
        return false;
    return true;
}
export function CandidateMinimumFromJSON(json) {
    return CandidateMinimumFromJSONTyped(json, false);
}
export function CandidateMinimumFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'cityName': json['cityName'],
        'searchLocationName': json['searchLocationName'],
        'searchLocationRadius': json['searchLocationRadius'],
        'yearsExperience': NullableRangeDtoFromJSON(json['yearsExperience']),
        'educationLevel': json['educationLevel'],
        'personalCharacteristics': json['personalCharacteristics'],
        'personalityTypeId': json['personalityTypeId'],
        'lastFunctionTitle': json['lastFunctionTitle'] == null ? undefined : json['lastFunctionTitle'],
    };
}
export function CandidateMinimumToJSON(json) {
    return CandidateMinimumToJSONTyped(json, false);
}
export function CandidateMinimumToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'cityName': value['cityName'],
        'searchLocationName': value['searchLocationName'],
        'searchLocationRadius': value['searchLocationRadius'],
        'yearsExperience': NullableRangeDtoToJSON(value['yearsExperience']),
        'educationLevel': value['educationLevel'],
        'personalCharacteristics': value['personalCharacteristics'],
        'personalityTypeId': value['personalityTypeId'],
        'lastFunctionTitle': value['lastFunctionTitle'],
    };
}
